export const CHANGE_CVIP_MES = 'CHANGE_CVIP_MES' //切换vip状态
export const CHANGE_CVIP_FROM = 'CHANGE_CVIP_FROM' //vip 来源



// WEBPACK FOOTER //
// ./src/store/mutation-types.js